import ChartController from "./chart_controller.js"

// Connects to data-controller="chart-vermoegensverlauf"
export default class extends ChartController {
	static targets = ["data", "chartbutton", "checkboxNominalReal", "planungsinflation"]
	static values = {
		startdatum: Number,
		enddatum: Number,
	}

	connect() {
		// Chart initialisieren
		this.chart.data.startdatum = this.startdatumValue
		this.chart.data.enddatum = this.enddatumValue
		this.chart.init()
	}

	dataTargetConnected() {
		// console.log("chart-vermoegensverlauf#dataTargetConnected")
		// Wenn ein neues Target Div mit den Chartdaten das alte ersetzt (durch Stream oder replace)
		// muss das Chart aktualisiert werden
		this.setChartData()
		this.chart.update()
	}

	// Diese Methode wird für den Wechsel zwischen Nettovermögen und Gesamtvermoegen Chart verwendet.
	changeChartSeries({ currentTarget, params }) {
		if (this.chartbuttonTargets.includes(currentTarget)) {
			this.chartbuttonTargets.forEach((e) => e.removeAttribute("data-ui"))
			currentTarget.dataset.ui = "aktiv"
		}

		switch (params.series) {
			case "nettovermoegen":
				this.chart.updateSeriesData(this.chart.seriesNettovermoegen)
				this.chart.updateYAxis(2) // 2 Y-Achsen
				break
			case "gesamtvermoegen":
				this.chart.updateSeriesData(this.chart.seriesGesamtvermoegen)
				this.chart.updateYAxis(1) // 1 Y-Achse
				break
			default:
				console.error("Keine Series im Chart gefunden")
		}
		// Ueberpruefen, ob der Realwert angezeigt werden muss
		if (this.checkboxNominalRealTarget.checked) this.changeChartNettowert(this.chart.chart, "real")
	}

	// Diese Methode wird für den Wechsel zwischen Real- und Nominalvermögen im Chart verwendet.
	changeNominalReal({ currentTarget }) {
		const format = currentTarget.checked ? "real" : "nominal"
		this.changeChartNettowert(this.chart.chart, format)
	}

	// Private Methods

	setChartData() {
		const data = JSON.parse(this.dataTarget.dataset.chartdata)
		this.chart.seriesNettovermoegen = data.nettovermoegen
		this.chart.seriesGesamtvermoegen = data.gesamtvermoegen
	}

	changeChartNettowert(chart, format) {
		chart.series.forEach((serie) => {
			if (format === "nominal") {
				serie.setData(serie.options.dataNominal, false)
			} else if (format === "real") {
				serie.setData(serie.options.dataReal, false)
			}
		})
		// Chart-Animation
		chart.options.chart.werteDarstellung = format
		chart.redraw({ duration: chartAnimationDuration })
	}
}
